import * as React from 'react';
import { observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router';

import { ConfirmationPage } from './desktop/confirmation-page';
import { Estimate } from 'src/api';
import { EstimateStore } from '../../stores/estimate.store';
import { lazyInject } from '../../ioc';
import { RouteParams as RouteParamsBase } from '../estimate-routes';
import { RouterStore } from 'src/core/stores/router.store';

type RouteParams = Required<RouteParamsBase>;

@observer
export class ConfirmationPageContainer extends React.Component<RouteComponentProps<RouteParams>> {
    @lazyInject(EstimateStore) private estimateStore!: EstimateStore;
    @lazyInject(RouterStore) private router!: RouterStore;

    estimate: Estimate | undefined;
    signDate = new Date().toDateString();
    bundleHasUnsignedEstimates: boolean = false;
    private bundleId: string;
    private estimateId: string;

    constructor(props: RouteComponentProps<RouteParams>) {
        super(props);
        this.bundleId = props.match.params.bundleId;
        this.estimateId = props.match.params.estimateId;
        if (this.estimateStore.estimateBundle) {
            const estimates = this.estimateStore.estimateBundle.estimates;
            this.estimate = estimates.find((e) => e.id === this.estimateId);
            this.bundleHasUnsignedEstimates = estimates.filter((e) => !e.isAccepted).length >= 1;
        }
        if (!this.estimate) {
            this.estimateStore.gotoEstimate(this.estimateId, props.match.params.bundleId, true);
            return;
        }
    }

    gotoEstimate = () => {
        this.router.history.push(`/estimate/${this.bundleId}`);
    };

    render() {
        return <ConfirmationPage container={this} />;
    }
}
